import { useEffect } from 'react';
import { useStoreWithEqualityFn } from 'zustand/traditional';

import { useSubscription } from '~/stores/use-subscription/useSubscription';

import { useLivePriceStore } from './use-live-price-store/useLivePriceStore';
import {
  Identifier,
  LivePriceData,
  PriceEntity,
  SubscribeFn,
} from './use-live-price-store/useLivePriceStore.utils';

interface StateSlice {
  subscribe: SubscribeFn;
  livePriceData: LivePriceData;
}

export const bindEquityFnWithEntities =
  (priceEntities: PriceEntity[]) =>
  (prevState: StateSlice, currentState: StateSlice) =>
    priceEntities.every(e => {
      const subscribable_ticker = e.entity.subscribable_ticker;

      if (!subscribable_ticker) {
        return true;
      }

      return (
        prevState.livePriceData[subscribable_ticker] ===
        currentState.livePriceData[subscribable_ticker]
      );
    });

export const useLivePrice = (
  priceEntities: PriceEntity[],
  identifier?: Identifier
) => {
  const isBasicUser = useSubscription(state => state.isBasicUser());
  const { subscribe, livePriceData } = useStoreWithEqualityFn(
    useLivePriceStore,
    s => ({
      subscribe: s.subscribe,
      livePriceData: s.livePriceData,
    }),
    bindEquityFnWithEntities(priceEntities)
  );

  useEffect(() => {
    if (!priceEntities?.length) {
      return undefined;
    }

    return subscribe({
      priceEntities,
      identifier,
      delayedPrices: isBasicUser,
    });
  }, [priceEntities.map(e => e.entity.subscribable_ticker).join(' ')]);

  return livePriceData;
};
